import { TMetricData } from '../metric_table/types';

export const prepareMetricData = (metricData?: TMetricData) => {
  return metricData?.map((data) => {
    return (
      Object.fromEntries(
        Object.entries(data).map(([k, v]) => [k.toLowerCase(), v])
      ) ?? []
    );
  });
};
